// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610062106/js/" + chunkId + "." + {"44":"3db9fd93","225":"0f9ee47b","481":"cd8fa6f6","486":"eba19cd6","770":"11d91a3e"}[chunkId] + ".0.6938617714447922.chunk.js";
};